/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import React from 'react';

import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import TextArea from 'ui-library/bs/TextArea';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';

const CUSTOM_BARCODE = 'custom-barcode';
const AUTOGENERATE_BARCODE = 'autogenerate-barcode';

interface Props {
  customBarcode: string;
  error?: string;
  shouldAutogenerateBarcode: boolean;
  onUpdate: (...args: Array<any>) => any;
}

class BarcodeInput extends React.Component<Props> {
  _handleChangeShouldAutogenerateBarcode = (e: any): void => {
    this.props.onUpdate({
      shouldAutogenerateBarcode: e.target.value === AUTOGENERATE_BARCODE,
    });
  };

  _handleChangeCustomBarcode = (e: any): void => {
    this.props.onUpdate({
      customBarcode: e.target.value,
    });
  };

  render(): JSX.Element {
    return (
      <FormGroup>
        <Row bufferRowReset={true}>
          <Col md={12}>
            <FieldLabel isRequired={true} label="Barcode" labelStyle={FieldLabel.STYLES.LABEL} />
          </Col>
        </Row>
        <Row bufferRowReset={true}>
          <Col md={6}>
            <input
              checked={this.props.shouldAutogenerateBarcode}
              onChange={this._handleChangeShouldAutogenerateBarcode}
              type="radio"
              value={AUTOGENERATE_BARCODE}
            />
            <span className="u-tiny-spacing-left">Autogenerate</span>
          </Col>
          <Col md={6}>
            <input
              checked={!this.props.shouldAutogenerateBarcode}
              onChange={this._handleChangeShouldAutogenerateBarcode}
              type="radio"
              value={CUSTOM_BARCODE}
            />
            <span className="u-tiny-spacing-left">Custom</span>
          </Col>
        </Row>
        {!this.props.shouldAutogenerateBarcode && (
          <Row bufferRowReset={true}>
            <Col md={12}>
              <TextArea
                placeholder="Barcode"
                value={this.props.customBarcode}
                onChange={this._handleChangeCustomBarcode}
                className={classNames({'fieldInput-input--error': this.props.error != null})}
                rows={1}
              />
              {this.props.error ? <ErrorMessage error={this.props.error} /> : null}
            </Col>
          </Row>
        )}
      </FormGroup>
    );
  }
}

export default BarcodeInput;
